export const ACTION_TYPES = {
    CHANGE_PAGE: "changePage",
    SET_SALE_DATA: "setSaleData",
    SET_LOGIN_CONFIG: "setLoginConfig",
    SET_LANGUAGE: "setLanguage",
};
